import React, { useEffect, useState } from "react";
import { Users, Boxes, ShieldCheck, Activity } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

const stats = [
  { key: "users", label: "Total Users", icon: Users },
  { key: "apps", label: "Connected Apps", icon: Boxes },
  { key: "active_sessions", label: "Active Sessions", icon: ShieldCheck },
  { key: "logins_24h", label: "Logins (24h)", icon: Activity },
];

export default function AdminOverview() {
  const [data, setData] = useState({});
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const s = await api.get("/admin/stats");
        setData(s.data);
        const a = await api.get("/admin/audit?limit=8");
        setRecent(a.data);
      } catch { /* ignore */ }
    })();
  }, []);

  return (
    <div className="p-8 max-w-6xl">
      <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono">// dashboard</div>
      <h1 className="font-display text-4xl font-semibold tracking-tight mt-1">Overview</h1>
      <p className="text-sm text-zinc-400 mt-2">A snapshot of your identity provider.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-8">
        {stats.map((s) => (
          <Card key={s.key} className="bg-zinc-900/60 border-zinc-800 p-4" data-testid={`stat-${s.key}`}>
            <div className="flex items-center justify-between">
              <s.icon className="w-4 h-4 text-zinc-500" />
              <span className="text-[10px] uppercase text-zinc-600 font-mono tracking-widest">{s.label}</span>
            </div>
            <div className="mt-3 font-display text-3xl font-semibold tabular-nums">{data[s.key] ?? "—"}</div>
          </Card>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="font-display text-lg font-medium mb-3">Recent activity</h2>
        <Card className="bg-zinc-900/60 border-zinc-800 divide-y divide-zinc-800">
          {recent.length === 0 && (
            <div className="p-8 text-center text-sm text-zinc-500 border-dashed">No activity yet.</div>
          )}
          {recent.map((r) => (
            <div key={r.id} className="px-4 py-2.5 grid grid-cols-12 items-center text-xs hover:bg-zinc-900/80">
              <div className="col-span-3 font-mono text-zinc-500">{new Date(r.created_at).toLocaleString()}</div>
              <div className="col-span-3 font-mono text-zinc-300">{r.action}</div>
              <div className="col-span-4 text-zinc-400 truncate font-mono">{r.detail}</div>
              <div className="col-span-2 text-right font-mono text-zinc-500 truncate">{r.ip_address}</div>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
